import { render, staticRenderFns } from "./GMBReviewInsights.vue?vue&type=template&id=bdcc60b4&scoped=true"
import script from "./GMBReviewInsights.vue?vue&type=script&lang=js"
export * from "./GMBReviewInsights.vue?vue&type=script&lang=js"
import style0 from "./GMBReviewInsights.vue?vue&type=style&index=0&id=bdcc60b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdcc60b4",
  null
  
)

export default component.exports